import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { Loader } from './components/loaders/loader';
import { useUser } from './lib/hooks/use-user';

type WithAuthProps = {};

export const WithAuth: FC<WithAuthProps> = ({ children }) => {
  const { isLoading, user } = useUser();

  if (isLoading) {
    return <Loader bgColor="#f0f4f7" />;
  }

  if (Boolean(user?.plan)) {
    return <>{children}</>;
  }

  return <Navigate to={AppRoutes.SIGN_IN.get()} />;
};

export const AppRoutes = {
  MAIN: {
    get: () => '/',
  },
  CAMPAIGN: {
    get: () => '/campaign/:id',
    getComputed: (id: number) => `/campaign/${id}`,
  },
  EMBED: {
    get: () => '/embed/:campaignId',
    match: (path: string) => path.includes('/embed/'),
  },
  CAMPAIGN_STATISTICS: {
    get: () => '/campaign/:id/statistics',
    getComputed: (id: number) => `/campaign/${id}/statistics`,
  },
  COUPONS: {
    get: () => '/coupons',
  },
  ACCOUNT: {
    get: () => '/account',
  },
  SIGN_IN: {
    get: () => '/sign-in',
  },
  CODE: {
    get: () => '/code',
  },
  USER_WIDGET: {
    get: () => '/widget/:userUuid/:campaignId',
    getComputed: (userUuid: string, campaignId: number) => `/widget/${userUuid}/${campaignId}`,
    match: (path: string) => path.includes('/widget/'),
  },
  USER_WIDGET_WIX: {
    get: () => '/wix/:wixInstanceId/:campaignId',
    getComputed: (wixInstanceId: string, campaignId: number) => `/wix/${wixInstanceId}/${campaignId}`,
    match: (path: string) => path.includes('/wix/'),
  },
};

export const ROOT_ROUTES = [AppRoutes.MAIN, AppRoutes.COUPONS, AppRoutes.ACCOUNT, AppRoutes.CODE];

export const rootPaths = ROOT_ROUTES.map((route) => route.get());

export const isPreviewPage = (pathname: string): boolean => {
  return (
    AppRoutes.EMBED.match(pathname) ||
    AppRoutes.USER_WIDGET.match(pathname) ||
    AppRoutes.USER_WIDGET_WIX.match(pathname)
  );
};
